<template>
    <el-dialog :title="`${isEdit ? '编辑':'添加'}学校`" :visible.sync="showDialog">
        <component is="el-form" ref="ruleForm" :rules="rules" :key="preventKey" :model="ruleForm"
                   class="form-beauty form-col"
                   label-width="130px">
            <el-form-item label="学校名称" prop="name">
                <el-input v-model.trim="ruleForm.name" :maxlength="50" placeholder="请输入"></el-input>
            </el-form-item>
            <el-row :gutter="20">
                <el-col :span="11">
                    <el-form-item label="省份名称" prop="provinceId">
                        <el-select @change="provinceChange" filterable v-model="ruleForm.provinceId" placeholder="请选择"
                                   :clearable="true">
                            <el-option v-for="(item, index) in selectMap.WB_PROVINCE_ALL_WITH_CITY"
                                       :key="item.value"
                                       :label="item.text"
                                       :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="2" class="text-right">
                    <i class="el-icon-my-gengduo1"
                       style="font-size: 24px;vertical-align: middle;color: #ddd;position: relative;top: 5px;"></i>
                </el-col>
                <el-col :span="11">
                    <el-form-item label="城市名称" prop="cityId" label-width="90px">
                        <el-select v-model="ruleForm.cityId" filterable :clearable="true"
                                   placeholder="请选择">
                            <el-option v-for="(item, index) in cityArr"
                                       :key="item.value"
                                       :label="item.text"
                                       :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="学校类型" prop="type">
                <el-select v-model="ruleForm.type" placeholder="请选择" :clearable="true">
                    <el-option v-for="(item, key) in selectMap.WB_SCHOOL_TYPES" :key="key"
                               :label="item.text" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="学校档位" prop="sLevel">
                <el-select v-model="ruleForm.sLevel" placeholder="请选择" :clearable="true">
                    <el-option v-for="(item, key) in selectMap.WB_SCHOOL_LEVEL" :key="key"
                               :label="item.text" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
        </component>
        <div slot="footer" class="mb-10">
            <el-button @click="submitForm('ruleForm', true)">保存</el-button>
            <el-button @click="submitForm('ruleForm', false)" type="primary" v-if="!isEdit">保存并继续添加</el-button>
        </div>
    </el-dialog>
</template>
<script type="text/javascript">
    import selectMapMixin from 'mixins/selectMapMixin'
    import formCommonMixin from 'mixins/formCommonMixin'
    import pattern from 'modules/pattern'
    import rules from 'modules/rules'
    import {dateFormat} from 'modules/tools'

    const Model = {
        id: '',
        name: '',           // 学校名称
        provinceId: '',     // 省份名称
        cityId: '',         // 城市名称
        type: '',           // 学校类型
        sLevel: ''          // 学校档位
    }
    export default {
        mixins: [selectMapMixin, formCommonMixin],
        data () {
            return {
                urls: {
                    add: '/system/school/level/save.api',
                    update: '/system/school/level/save.api'
                },
                showDialog: false,
                isEdit: false,
                preventKey: 1,
                ruleForm: Object.assign({}, Model),
                cityArr: [],
                rules: {
                    name: {required: true, message: '请输入', trigger: 'blur'},
                    provinceId: {required: true, message: '请选择', trigger: 'blur'},
                    cityId: {required: true, message: '请选择', trigger: 'blur'},
                    type: {required: true, message: '请选择', trigger: 'blur'},
                    sLevel: {required: true, message: '请选择', trigger: 'blur'}
                }
            }
        },
        methods: {
            show (data) {
                this.preventKey++
                if (data) {
                    Object.keys(this.ruleForm).forEach(key => {
                        this.ruleForm[key] = typeof data[key] === 'number' ? ((data[key] && String(data[key])) || '') : data[key]
                    })
                    this.provinceChange(this.ruleForm.provinceId)
                } else {
                    this.ruleForm = Object.assign({}, Model)
                }
                this.isEdit = Boolean(data && data.id)
                this.showDialog = true
            },
            saveForm (boolean) {
                // 提交表单
                this.$axios.post(this.ruleForm.id ? this.urls.update : this.urls.add, this.ruleForm, {'X-showMessage': true}).then(res => {
                    this.resetForm('ruleForm')
                    if (boolean === true) {
                        this.showDialog = false
                    } else {
                        this.ruleForm.id = ''
                    }
                    this.$emit('reload')
                }).catch(() => {
                })
            },
            provinceChange (value) {
                let target = []
                this.selectMap.WB_PROVINCE_ALL_WITH_CITY.forEach((item, index) => {
                    if (item.value === value) {
                        target = item.list
                    }
                })
                let isExist = false
                if (target.length && this.ruleForm.cityId) {
                    isExist = target.filter(item => item.value === String(this.ruleForm.cityId)).length
                }
                this.cityArr = target
                !isExist && (this.ruleForm.cityId = '')
            }
        }
    }
</script>
<style type="text/css" lang="scss">

</style>


// WEBPACK FOOTER //
// addRecordDialog.vue?4295be84